<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y8HbqK/tc-custom/9781595588876.jpg?1734290702822" alt="This image is the cover for the book World Will Follow Joy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">World Will Follow Joy
      </h1>
      <p class="bookDescription body article font2">
        <b>A poetry collection of “playful and crooning lyricism” from the National Book Award– and Pulitzer Prize–winning author of <i>The Color Purple</i> (<i>Booklist</i>).</b><br/>  <br/> In this dazzling new collection, Alice Walker offers over sixty new poems to incite and nurture contemporary activists. Hailed as a “lavishly gifted writer,” Walker imbues her poetry with evocative images, fresh language, anger, forgiveness, and profound wisdom (<i>The New York Times</i>).<br/>  <br/> Casting her eye toward history, politics, and nature, as well as to world figures such as Jimmy Carter, Gloria Steinem, and the Dalai Lama, she “distills struggles, crises, and tragedies down to bright, singing lessons in living with awareness and joy” (<i>Booklist</i>).<br/>  <br/> By attentively chronicling the conditions of human life today, Walker shows, as ever, her deep compassion, profound spirituality, and necessary political commitments. The poems in <i>The World Will Follow Joy</i> remind us of our human capacity to come together and take action, even in our troubled political times. “Her spirituality, concern for human rights, and almost old-fashioned, determined joyousness run deep and her devoted readers will want to follow her as she turns ‘madness into flowers’” (<i>Library Journal</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Walker
      </h2>
      
      <p class="authorDescription body article">Alice Walker (b. 1944), one of the United States&rsquo; preeminent writers, is an award-winning author of novels, stories, essays, and poetry. In 1983, Walker became the first African-American woman to win a Pulitzer Prize for fiction with her novel <i>The Color Purple</i>, which also won the National Book Award. Her other novels include <i>The Third Life of Grange Copeland</i>, <i>Meridian</i>, <i>The Temple of My Familiar</i>, and <i>Possessing the Secret of Joy</i>. In her public life, Walker has worked to address problems of injustice, inequality, and poverty as an activist, teacher, and public intellectual.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16c4b986